import {useContext} from 'react';
import {LockscreenContext} from '../lib/lockscreenContext';

export const useLockscreen = () => useContext(LockscreenContext);
